module.exports = __webpack_public_path__ + "img/step2-t.ba97bc25.png";